import { useEffect, useState } from "react";
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "../../../components/Button/Button";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import SyncButton from "../../../components/SyncButton/SyncButton";
import { useListManager } from "../../../contexts/list.manager";
import { useUserStore } from "../../../contexts/userStore";
import FormUnits from "../FormUnits/FormUnits";
import ListUnits from "../ListUnits/ListUnits";
import "./ConsultaUnits.css";
import TagService from "../../../services/TagService";
import { DynamicIcon } from "../../../components/DynamicIcon/DynamicIcon";
import { capitalize, pluralizePortuguese } from "../../../utils/string";

const ConsultaUnits = () => {
	const { lineSelected } = useListManager();
	const [customInput1, setCustomInput1] = useState("");
	const [filters, setFilters] = useState("");
	const { selectedCondominio } = useUserStore();
	const navigate = useNavigate();
	const location = useLocation();
	const params = useParams();
	const [refreshKey, setRefreshKey] = useState(0);
	const [tag, setTag] = useState(null);

	async function fetchTag(externalId) {
		try {
			const response = await TagService.getTag(externalId);
			if (response.status === 200) {
				setTag(response.data);
			}
		} catch (error) {
			console.error("Error fetching tag:", error);
		}
	}

	useEffect(() => {
		if (params.tagExternalId) {
			fetchTag(params.tagExternalId);
		}
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					title={capitalize(pluralizePortuguese(tag?.name)) ?? 'Carregando...'}
					navigate={`../cadastro-units/${params.tagExternalId}`}
					buttonLabel="Adicionar"
					icon={tag?.icon ? <DynamicIcon iconName={tag.icon} size={19} color={'var(--textColor)'} /> : <MdOutlineMapsHomeWork size={20} color={'var(--textColor)'} />}
					aditionalButton2={tag && tag.linkableToUser &&
						<Button
							navigate={`/cadastro-batch-units/${params.tagExternalId}`}
							className={"button-white unit-batch-button"}
							label={"Adicionar em Lote"}
						/>
					}
					aditionalButton1={
						<SyncButton
							type={"unit"}
							selectedCondominio={selectedCondominio}
						/>
					}
				>
					<SearchInput
						value={customInput1}
						placeholder="Buscar"
						onChange={({ target }) => setCustomInput1(target.value)}
						onKeyPress={(e) =>
							e.key === "Enter" && setFilters(customInput1)
						}
					/>
				</SearchContainer>
				<Container>
					<ListUnits
						tag={tag}
						filters={filters}
						refreshKey={refreshKey}
					/>
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormUnits
					tag={tag}
					unit={lineSelected}
					type="consulta"
				/>
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaUnits;
